import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { useStyles } from './CurrentTimeIndicator.style'

interface CurrentTimeIndicatorProps {
  scale: number
}

const getCurrentMinutes = () => {
  const now = dayjs()
  return now.hour() * 60 + now.minute()
}

export const CurrentTimeIndicator = ({ scale }: CurrentTimeIndicatorProps) => {
  const { classes } = useStyles()
  const [currentMinutes, setCurrentMinutes] = useState(getCurrentMinutes)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMinutes(getCurrentMinutes())
    }, 60_000)
    return () => clearInterval(interval)
  }, [])

  const topPosition = currentMinutes * scale

  return (
    <div
      className={classes.indicator}
      style={{ top: topPosition }}
      data-testid="current-time-indicator"
    />
  )
}
